// Banner appearance
const bannerBlog = document.getElementById('blog-banner');
// console.log(cgNav);
var scrollFunc = function() {
  var y = window.scrollY;
  if (bannerBlog != null) {
    if (y >= 250) {
      bannerBlog.style.opacity = "1";
    }
    else {
      bannerBlog.style.opacity = "0";
    }  
  }
}
window.addEventListener("scroll", scrollFunc);

